import { VideoCustom } from "../../organisms/VideoCustom";

export const StickyVideo = () => {

    return (
        <div className="sticky top-0 h-screen w-full">
            <VideoCustom videoName="triggervideo" />
        </div>
    );
};